/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Feat_1_TitleInputs */

const en_b2b_feat_1_title = /** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Domain Routing`)
};

const es_b2b_feat_1_title = /** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrutamiento de Dominio Sovereign`)
};

const fr_b2b_feat_1_title = /** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routage de Domaine Sovereign`)
};

const de_b2b_feat_1_title = /** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Domain Routing`)
};

const id_b2b_feat_1_title = /** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perutean Domain Sovereign`)
};

/** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */
const ja_b2b_feat_1_title = en_b2b_feat_1_title;

/** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */
const zh_b2b_feat_1_title = en_b2b_feat_1_title;

/** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */
const ar_b2b_feat_1_title = en_b2b_feat_1_title;

/** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */
const it_b2b_feat_1_title = en_b2b_feat_1_title;

/** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */
const ru_b2b_feat_1_title = en_b2b_feat_1_title;

/** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */
const pt_b2b_feat_1_title = en_b2b_feat_1_title;

/** @type {(inputs: B2b_Feat_1_TitleInputs) => LocalizedString} */
const ko_b2b_feat_1_title = en_b2b_feat_1_title;

/**
* | output |
* | --- |
* | "Sovereign Domain Routing" |
*
* @param {B2b_Feat_1_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_feat_1_title = /** @type {((inputs?: B2b_Feat_1_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Feat_1_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_feat_1_title(inputs)
	if (locale === "es") return es_b2b_feat_1_title(inputs)
	if (locale === "fr") return fr_b2b_feat_1_title(inputs)
	if (locale === "de") return de_b2b_feat_1_title(inputs)
	if (locale === "ja") return ja_b2b_feat_1_title(inputs)
	if (locale === "zh") return zh_b2b_feat_1_title(inputs)
	if (locale === "ar") return ar_b2b_feat_1_title(inputs)
	if (locale === "id") return id_b2b_feat_1_title(inputs)
	if (locale === "it") return it_b2b_feat_1_title(inputs)
	if (locale === "ru") return ru_b2b_feat_1_title(inputs)
	if (locale === "pt") return pt_b2b_feat_1_title(inputs)
	return ko_b2b_feat_1_title(inputs)
});